import React, { useState } from 'react';
import Axios from 'axios';
import { useHistory } from 'react-router-dom';
import { spinnerService } from '../../shared/services/spinner.service';
import CONFIG from '../../configuration/config';
import ROUTES from '../../shared/constants/routes';
import { setData } from '../../shared/utils/storage.util';
import { msalInstance, loginRequest } from '../../shared/config/msalConfig';

const LoginComponent = () => {
  const history = useHistory();
  const [ssoLoading, setSsoLoading] = useState(false);
  const [ssoError, setSsoError] = useState(null);

  const handleSSOLogin = async () => {
    setSsoLoading(true);
    setSsoError(null);

    try {
      const loginResponse = await msalInstance.loginPopup(loginRequest);
      const idToken = loginResponse.idToken;

      spinnerService.show('Oval', 'Verifying Access');

      const response = await Axios.post(
        CONFIG.ssoLogin,
        { idToken },
        { headers: { 'Content-Type': 'application/json' } }
      );

      spinnerService.hide('Oval');

      if (response.data.responseCode === 200 && response.data.success) {
        const loginData = { userData: response.data.response };
        setData('auth', response.data.response.token);
        setData('isLogin', true);
        setData('loginData', loginData);
        setData('token', response.data.response.token);
        history.push(ROUTES.DASHBOARD);
      } else if (response.data.responseCode === 403) {
        history.push(ROUTES.NO_ACCESS);
      } else {
        setSsoError(response.data.message || 'Login failed.');
      }
    } catch (error) {
      spinnerService.hide('Oval');
      if (error.errorCode) {
        if (error.errorCode !== 'user_cancelled') {
          setSsoError('SSO login failed. Please try again.');
        }
      } else {
        if (error.response && error.response.data && error.response.data.responseCode === 403) {
          history.push(ROUTES.NO_ACCESS);
        } else {
          setSsoError('Unable to verify access. Please try again.');
        }
      }
    } finally {
      setSsoLoading(false);
    }
  };

  return (
    <div className="login-main">
      <a href="" onClick={(e) => e.preventDefault()} className="login-logo">
        <img src={require('../../assets/images/niagara-logo-color-2-x.png')} alt="Login Logo" />
      </a>
      <div className="login-form-container">
        {ssoError && (
          <div className="sso-error-message">
            <p>{ssoError}</p>
          </div>
        )}
        <div className="login-btn">
          <button
            className="btn-prmry"
            onClick={handleSSOLogin}
            disabled={ssoLoading}>
            {ssoLoading ? 'Signing in...' : 'Sign in with Niagara SSO'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default LoginComponent;
